import { c as _c } from "react/compiler-runtime";
// Copied from shared-ui 0.15.3 (loanlight-shared 6c73887) packages/ui/src/primitives/divider.tsx
import clsx from "clsx";
export function Divider(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      soft: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const soft = t1 === undefined ? false : t1;
  const t2 = soft && "border-brand-200/70 dark:border-white/5";
  const t3 = !soft && "border-brand-200 dark:border-white/10";
  let t4;
  if ($[4] !== className || $[5] !== t2 || $[6] !== t3) {
    t4 = clsx(className, "w-full border-t", t2, t3);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t4) {
    t5 = <hr role="presentation" {...props} className={t4} />;
    $[8] = props;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}